import {
    SELF_EVALUATION_ICONS_FETCHING,
    SELF_EVALUATION_ICONS_SUCCESS,
    SELF_EVALUATION_ICONS_ERROR
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    selfEvaluationIcons: {},
    selfEvaluationIconsFetching: false,
    selfEvaluationIconsFetchFail: false
};

const fetchingSelfEvaluationIcons = (state) => {
    return {
        ...state,
        selfEvaluationIconsFetching: true,
        selfEvaluationIconsFetchFail: false
    };
};

const selfEvaluationIconsFetchFail = (state) => {
    return {
        ...state,
        selfEvaluationIconsFetching: false,
        selfEvaluationIconsFetchFail: true
    };
};

const selfEvaluationIconsFetchSuccess = (state, action) => {
    return {
        ...state,
        selfEvaluationIcons: {
            ...action.response.data.icons
        },
        selfEvaluationIconsFetching: false,
        selfEvaluationIconsFetchFail: false
    };
};

export const getSelfEvaluationIcons = (state) => {
    return state.workoutExecutionMetrics.selfEvaluationIcons;
};

const handlers = {
    [SELF_EVALUATION_ICONS_FETCHING]: fetchingSelfEvaluationIcons,
    [SELF_EVALUATION_ICONS_SUCCESS]: selfEvaluationIconsFetchSuccess,
    [SELF_EVALUATION_ICONS_ERROR]: selfEvaluationIconsFetchFail
};

export default function workoutExecutionMetrics(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
